import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import { initClient } from '@/services/initClient.ts'
import { initSentry } from '@/services/sentry.ts'
import './styles/index.css'
import i18n from './i18n'

// Initialize Sentry after i18n so the feedback widget matches the UI language
initSentry(i18n.t.bind(i18n))

// Expose Sentry on window in non-production for console testing (e.g. Sentry.captureException(new Error('test')))
const isProduction = window.RUNTIME_CONFIG?.SENTRY_ENVIRONMENT?.toUpperCase() === 'PRODUCTION'
if (!isProduction) {
	window.Sentry = Sentry
}

// Initialize API client
initClient()

const rootElement = document.getElementById('root')
if (!rootElement) {
	throw new Error('Root element not found')
}

const root = ReactDOM.createRoot(rootElement, {
	onUncaughtError: Sentry.reactErrorHandler(),
})

root.render(
	<React.StrictMode>
		<Sentry.ErrorBoundary
			fallback={
				<div style={{ padding: 16, fontFamily: 'sans-serif' }}>
					<p>Something went wrong. The error has been reported.</p>
				</div>
			}
		>
			<App />
		</Sentry.ErrorBoundary>
	</React.StrictMode>
)
